import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function FootballNav({open, opener}) {
  const props = {
    open,
    opener,
    title: "Football",
    links: [
      {href: "/football", text: "News", isIndex: true},
      {href: "/football/live", text: "Live", isIndex: true},
      {href: "/football/fixtures", text: "Fixtures"},
      {href: "/football/results", text: "Results"},
      {href: "/football/league-tables", text: "Tables"},
      {href: "/football/paper-talk", text: "Paper Talk"},
      {href: "/football/tips-centre", text: "Tips"},
      {href: "https://www.skybet.com/football?aff=1197321690&dcmp=SL_NAV_FB_LO_19", text: "Latest Odds"}
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

FootballNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired
}

export default FootballNav



// WEBPACK FOOTER //
// ./modules/Football/nav/FootballNav.js